import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ErrorsService } from '../../../../../services/errors.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { Paginator } from 'primeng/paginator';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {
  public page = 0;
  public limit = 10;
  public totalRecords = 0;

  public search: string = '';
  public searchSubject: Subject<string> = new Subject<string>();
  private manualSearchTriggered: boolean = false;

  public errorLogs: any = [];
  public loading: boolean = false;

  public loadingTestErrorModal: boolean = false;


  @ViewChild('paginator') paginator: Paginator;

  constructor(
    private errorsService: ErrorsService,
    private router: Router,
  ) {
    // Subscribe to the subject and call the search function after 2 seconds of no input
    this.searchSubject.pipe(
      debounceTime(2000)  // Wait for 2 seconds
    ).subscribe(searchText => {
      if(this.manualSearchTriggered == true) return;
      this.searchErrorLog();
    });
  }

  ngOnInit() {
    this.getErrorLogs();
  }

  onSearchInput() {
    this.manualSearchTriggered = false;
    // Emit the value to the subject
    this.searchSubject.next(this.search);
  }

  getErrorLogs() {
    this.loading = true;
    this.errorsService
      .getErrorLogs(this.page, this.limit, this.search)
      .subscribe(
        (result: any) => {
          console.log(result);
          this.totalRecords = result.totalRecords; 

          this.errorLogs = result.errors.map(item => ({
            ...item,
            date: moment(item.date).format("YYYY-MM-DD HH:mm")
          }));

          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.error('Error fetching logs', err);
        },
      );
  }

  // Method for handling search functionality
  searchErrorLog() {
    this.page = 0; // Reset to first page when searching
    this.manualSearchTriggered = true; // Set the flag to true that we are
    this.getErrorLogs(); // Refresh logs
  }

  // Method to navigate to the specific error log details
  viewErrorLog(error: any) {
    console.log(error.id);
    this.router.navigate(['/administration/error', error.id]);
  }

  // Method to handle pagination change
  paginate(event: any) {
    this.page = event.page;
    this.limit = event.rows;
    this.getErrorLogs(); // Refresh logs for the new page
  }

  // Method to test error modal and to see how it works/looks
  testErrorModal(){
    this.loadingTestErrorModal = true;

    // Type 1 - 4 available

    this.errorsService
      .testErrorModal(1)
      .subscribe(
        (result: any) => {         
          // We shouldn't get here
          this.loadingTestErrorModal = false;
        },
        (err) => {
          this.loadingTestErrorModal = false;
          console.error('Test errror modal response:', err);
        },
      );
  }
}
